<template>
    <div>
        <Header></Header>
        <div>
            <div class="card-block">
                <h1>Пользователь #{{ $route.params.id }}<router-link class="button _free _second" to="/users">К списку</router-link></h1>
                <div class="tabs">
                    <router-link to="common">Общее</router-link>
                    <router-link to="user_transactions">Транзакции водителя</router-link>
                    <router-link to="owner_transactions">Транзакции собственника</router-link>
                </div>

                <router-view :loading="status_request" :pay_sum="pay_sum" :data.sync="data" :status="status" @showPopup="showPopup" @getData="getData" @updateData="updateData"></router-view>
                <div class="page-load" v-show="status == 'loading'">
                    <div class="inline" valign="center">
                        <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                    </div>
                </div>

                <div class="submit button _free" v-show="showButton" @click="update()">Сохранить</div>
            </div>
        </div>

        <ConfirmPopup :data.sync="popup" @confirm="pay"></ConfirmPopup>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import ConfirmPopup from '@/components/ConfirmPopup.vue'

    import popups from '@/mixins/popups'

    export default {
        mixins: [popups],
        components: {
            Header,
            ConfirmPopup
        },
        data () {
            return {
                data: {},
                data_backup: false,
                status_request: '',
                status: 'init',
                pay_sum: ''
            }
        },
        methods: {
            pay (amount) {
                this.status_request = 'loading'
                return new Promise((resolve, reject) => {
                    let path = this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1)
                    this.axios.post('api/admin/v2/users/' + this.$route.params.id + '/' + path, {
                        sum: amount,
                        date_from: this.data.date_from,
                        date_to: this.data.date_to
                    })
                        .then((resp) => {
                            this.status_request = ''

                            if (resp.data.errors) {
                                let msg = {
                                    message: resp.data.errors[0][1],
                                    status: 'error'
                                }
                                this.$store.dispatch('utils/showMessage', msg)
                            } else {
                                this.data = resp.data.response
                                this.pay_sum = ''
                                let msg = {
                                    message: 'Оплата проведена',
                                    status: 'success'
                                }
                                this.$store.dispatch('utils/showMessage', msg)
                            }
                            resolve()
                        })
                        .catch(() => {
                            this.status_request = ''
                            let msg = {
                                message: 'Ошибка при оплате',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            dateUpdate () {
                this.getData(this.data.date_from, this.data.date_to)
            },
            savedata () {
                this.data_backup = JSON.stringify(this.data)
            },
            getData(date_from = false, date_to = false) {
                return new Promise((resolve) => {
                    this.status = 'loading'

                    let method_name = this.activeSection

                    let params = ''
                    if (date_from && date_to) {
                        params += '?date_from=' + date_from + '&date_to=' + date_to
                    }

                    this.axios.get('api/admin/v2/users/' + this.$route.params.id + '/' + method_name + params)
                        .then(resp => {
                            this.data = resp.data.response
                            this.savedata()
                            this.status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/users')
                        })
                })
            },
            update () {
                let json = JSON.stringify(this.data)
                return new Promise((resolve, reject) => {
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/users/' + this.$route.params.id, json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(() => {
                        this.status_request = ''
                        this.savedata()
                        let msg = {
                            message: 'Данные обновлены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        resolve()
                    }).catch(() => {
                        this.status_request = ''
                        let msg = {
                            message: 'Ошибка при обновлении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            updateData(data) {
                this.data = data
                this.savedata()
            }
        },
        computed: {
            showButton () {
                if (JSON.stringify(this.data) == this.data_backup || this.status != '' || this.activeSection == 'user_transactions' || this.activeSection == 'owner_transactions') {
                    return false
                }
                return true
            },
            activeSection() {
                return this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
            }
        },
        created () {
            let self = this
            this.$router.beforeEach((to, from, next) => {
                self.data = {}
                self.status = 'loading'
                next()
            })
        }
    }
</script>
